import { render, staticRenderFns } from "./ApplePaySvg.vue?vue&type=template&id=6968c114&scoped=true&"
import script from "./ApplePaySvg.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ApplePaySvg.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6968c114",
  null
  
)

export default component.exports